import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { BillableItemEntity } from 'src/app/models/entities/project.entity';
import { TenantService } from '../../services/tenant.service';

@Injectable({
  providedIn: 'root',
})
export class BillableItemService {
  private tenantId: string = '';
  private dbPath: string = '';
  public currentBillableItem: BillableItemEntity | undefined;

  constructor(
    private afs: AngularFirestore,
    private tenantService: TenantService
  ) {
    this.tenantService.tenantId$.subscribe(tenantId => {
      if (tenantId) {
        this.tenantId = tenantId;
        this.dbPath = `${tenantId}/data/billableItems`;
      }
    });
  }

  public getBillableItem(billableItemId: string): AngularFirestoreDocument<BillableItemEntity> {
    return this.afs.doc<BillableItemEntity>(`${this.dbPath}/${billableItemId}`);
  }

  public getBillableItems(): Observable<BillableItemEntity[]> {
    // Access the billableItems collection and include the document ID as the 'key' property
    return this.afs.collection<BillableItemEntity>(this.dbPath).valueChanges({ idField: 'key' });
  }

  public getBillableItemsForClient(clientKey: string): Observable<BillableItemEntity[]> {
    // Use a query to filter the billable items by clientId
    return this.afs.collection<BillableItemEntity>(this.dbPath, ref => 
        ref.where('client', '==', clientKey))
        .valueChanges({ idField: 'key' });
  }

  public updateBillableItem(billableItemId: string, item: any): Promise<void> {
    const itemDoc: AngularFirestoreDocument<BillableItemEntity> = this.afs.doc<BillableItemEntity>(`${this.dbPath}/${billableItemId}`);
    return itemDoc.update(item);
  }

  public addBillableItem(item: any): Promise<string> {
    const billableItemsCollection: AngularFirestoreCollection<BillableItemEntity> = this.afs.collection<BillableItemEntity>(`${this.dbPath}`);
    return billableItemsCollection.add(item).then(docRef => docRef.id);
  }

  public deleteBillableItem(billableItemId: string): Promise<void> {
    return this.afs.doc(`${this.dbPath}/${billableItemId}`).delete();
  }
}
